// Shared helpers for the counter-maker "walk-to-market" param fields
// (step interval in seconds + step size in cents). Used by both the opener
// (EntryTabByPath) and unwinder (UnwindingTabSumOfSides) so their walk inputs
// validate and dirty-track identically and drive the same confirmation tic (✓).

// Parse a raw walk input string to the value we persist:
//   - blank      -> null  (walk disabled for that field)
//   - valid >= 1 integer -> the number
//   - anything else -> undefined  (invalid; the caller should NOT save)
export function parseWalkInput(input: string): number | null | undefined {
  const trimmed = input.trim();
  if (trimmed === '') return null;
  const n = Number(trimmed);
  if (Number.isInteger(n) && n >= 1) return n;
  return undefined;
}

// A walk field is dirty (shows the confirmation tic) when the current input
// differs from the last committed value.
export function isWalkFieldDirty(input: string, saved: string): boolean {
  return input !== saved;
}
